// Portfolio project data. Videos hosted on Cloudinary.
export const projects = [
  {
    id: "deportivo",
    index: "01",
    title: "Interturnos TSC",
    category: "Sports · Reel",
    year: "2025",
    src: "https://res.cloudinary.com/jqvef0es/video/upload/v1783186070/Deportivo_ok_lc6ywv.mp4",
    description:
      "Un retrato del pulso deportivo: cuerpo, ritmo y voluntad. Reel en vertical construido para redes con foco en la intensidad del movimiento.",
  },
  {
    id: "imusa",
    index: "02",
    title: "Productos IMUSA",
    category: "Branded · Producto",
    year: "2025",
    src: "https://res.cloudinary.com/jqvef0es/video/upload/v1783185971/imusa_reel_3_v3_vvic0m.mp4",
    description:
      "Pieza de marca para IMUSA. Cocina, textura y objeto elevados a lenguaje audiovisual con dirección de arte cuidada.",
  },
  {
    id: "primavera",
    index: "03",
    title: "Primavera en Distrito",
    category: "Dirección de Fotografía",
    year: "2025",
    src: "https://res.cloudinary.com/jqvef0es/video/upload/v1783185761/Reel_Primavera_DP_uebym7.mp4",
    description:
      "Muestra de dirección de fotografía en formato reel. Luz natural, encuadres precisos y una edición que transmite una atmosfera de calma.",
  },
  {
    id: "barrio",
    index: "04",
    title: "Un Barrio Abierto para Todos",
    category: "Guion y edición",
    year: "2025",
    src: "https://res.cloudinary.com/jqvef0es/video/upload/v1783185736/Reel_Un_Barrio_Abierto_para_todos_t1ib9u.mp4",
    description:
      "Un reel guionado que presenta un concepto desde una mirada cercana y aspiracional.",
  },
  {
    id: "tsc",
    index: "05",
    title: "Trailer New Balance",
    category: "Trailer · Evento",
    year: "2025",
    src: "https://res.cloudinary.com/jqvef0es/video/upload/v1783185925/Trailer_TSC_viernes_oxftrd.mp4",
    description:
      "Desarrollo de narrativa, dirección de cámara y ritmo visual para construir una pieza dinámica, cercana y con identidad audiovisual.",
  },
  {
    id: "fastwash",
    index: "06",
    title: "Fastwash",
    category: "Motion Graphics",
    year: "2025",
    src: "https://res.cloudinary.com/jqvef0es/video/upload/v1783185762/carrusel_animado_fastwash_gglucc.mp4",
    description:
      "Ritmo visual, sfx, la síntesis gráfica y la animación se integran para construir una narrativa clara, dinámica y atractiva.",
  },
];
